import { ImagePinComponent, Size, Vector } from '../../models';
import { newBox, newSize } from '../geometry';
import { defaultOrder } from '../order';
import { randomId } from '../random-id';
import { initialPinComponentPosition } from './pin-component';

type NewImagePinComponentProps = {
  url?: string;
  position?: Vector;
  size?: Size;
  rotation?: number;
  order?: string;
  settings?: Partial<ImagePinComponent['settings']>;
  id?: string;
};

export function newImagePinComponent({
  url = '',
  position = initialPinComponentPosition,
  size = newSize(175, 175),
  rotation = 0,
  order = defaultOrder,
  settings,
  id,
}: NewImagePinComponentProps): ImagePinComponent {
  return {
    type: 'IMAGE',
    id: id || randomId(),
    settings: {
      ...settings,
      url,
    },
    layout: newBox(position, size, rotation),
    order,
  };
}
